import { Box, Image, Spacer } from '@jfs/ui-new'
import { useState } from 'react'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { ScanUserAuth } from '../../comps/ScanUserAuth'
import { Title } from '../../comps/Title'

interface FingerPrintScannerProps {
  onSubmit: any
  isLoading: boolean
  consent: string
  title?: string
}

export const FingerPrintScanner = ({
  onSubmit,
  isLoading,
  consent,
  title = 'AADHAAR Consent',
}: FingerPrintScannerProps) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Container showFooter={true}>
      <Box f={1} overflow={'scroll'}>
        <Box alignItems={'center'}>
          <Image source={require('../../assets/icons/ic_consent.png')} width={100} height={82} />
        </Box>
        <Spacer size={24} />
        <Title title={title} />
        <Spacer size={40} />

        <AepsCheckBox checked={isChecked} onChange={(checked: any) => setIsChecked(checked)} text={consent} />
        <Spacer size={24} />
      </Box>

      <ScanUserAuth onPress={onSubmit} isLoading={isLoading} disabled={!isChecked} allowedModes={['FACE']}/>
    </Container>
  )
}
